import { useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (password.length < 6) return alert("Password must be at least 6 characters");
    
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess(true);
      // Redirect to login after 3 seconds
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    } catch (err) {
      alert(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>New Password</h1>
        
        {success ? (
          <div style={styles.successBox}>
            <p style={styles.subtitle}>Password updated successfully! Redirecting you to login...</p>
          </div>
        ) : (
          <>
            <p style={styles.subtitle}>Enter your new secure password below.</p>
            <form onSubmit={handleUpdatePassword} style={{ textAlign: 'left' }}>
              <label style={styles.label}>New Password</label>
              <input 
                style={styles.input} 
                type="password" 
                placeholder="••••••••" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required
              />
              <button style={styles.button} type="submit" disabled={loading}>
                {loading ? "Updating..." : "Update Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "#f1f5f9", padding: "20px" },
  card: { width: "100%", maxWidth: "380px", padding: "40px", borderRadius: 32, background: "#fff", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.1)", textAlign: "center" },
  title: { fontSize: "28px", fontWeight: "900", color: "#0f172a", marginBottom: "8px", fontStyle: "italic" },
  subtitle: { fontSize: "14px", color: "#64748b", marginBottom: "24px", lineHeight: "1.5" },
  label: { display: "block", fontSize: "11px", fontWeight: "800", color: "#475569", marginBottom: "6px", textTransform: "uppercase" },
  input: { width: "100%", padding: "14px", marginBottom: "18px", borderRadius: "12px", border: "1px solid #e2e8f0", outline: "none", boxSizing: "border-box" },
  button: { width: "100%", padding: "16px", borderRadius: "12px", border: "none", background: "#2563eb", color: "#fff", fontWeight: "800", cursor: "pointer", textTransform: "uppercase" },
  successBox: { padding: "20px", background: "#f0fdf4", borderRadius: "16px", border: "1px solid #bbf7d0" }
};